import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';

import { PartialFormField } from '../../form-fields/form-field.types';
import { InlineFieldInterfaceComponent } from '../inline-field-interface.component';

@Component({
  templateUrl: './select-inline-field.component.html',
  styleUrls: ['./select-inline-field.component.scss'],
})
export class SelectInlineFieldComponent implements InlineFieldInterfaceComponent, OnInit {
  @Input() model: any;
  @Input() fieldDef: any;
  @Input() data: any;
  @Input() excludeLabels: boolean = false;
  @Input() readonly: boolean = false;
  @Input() canClick: boolean = false;
  @Output() onClick: EventEmitter<PartialFormField> = new EventEmitter();
  @Output() update: EventEmitter<PartialFormField> = new EventEmitter();

  public options: any[];
  public filteredOptions: any[];
  public value: string = '';
  public editing: boolean = false;
  public showTip: string;
  private _readonly: boolean;
  public multiple: boolean = false;

  ngOnInit() {
    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];

    this.showTip = this.fieldDef.meta?.calc_code;

    this.multiple = this.fieldDef.meta?.multi_select;

    if (!this.fieldDef.meta.option_name) {
      const options = this.fieldDef.meta?.options ?? [];
      this.options = options.map((value) => ({ id: value, name: value }));
    } else {
      this.options = this.data.options[this.fieldDef.meta.option_name];

      this.options = this.options.filter((option) => {
        if (option.hidden) {
          return false;
        } else {
          if (option?.pipeline_ids) {
            if (this.model.pipeline_id) {
              return option?.pipeline_ids.map((id) => String(id)).includes(String(this.model.pipeline_id));
            }
          }
        }
        return true;
      });

      if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
        this._readonly = this.fieldDef.meta.readonly;
      }

      if (this.readonly) {
        this._readonly = this.readonly;
      }

      this.readonly = this._readonly;
    }

    this.filteredOptions = this.options;
  }

  clickField(event): void {
    this.onClick.emit(event);
  }
}
